module.exports = __webpack_public_path__ + "static/media/Autodesk University Shorter Form Content.fd3c1922.png";